import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import useLayoutTypeContext from '../hooks/useLayoutTypeContext';

const AryWrapper = ({
  backgroundColor,
  width,
  height,
  padding,
  border,
  style,
  children,
  borderRadius = '2px',
  borderSize = '1px'
}) => {
  const theme = useTheme();
  const layoutType = useLayoutTypeContext();

  const BoxStyle = {
    width: width || '100%',
    height: height || 'auto',
    borderRadius: layoutType === 'mobile' ? borderRadius : '4px',
    backgroundColor: backgroundColor || theme.wrapper.background.default,
    padding: padding || theme.padding.aryWrapper,
    border:
      border === 'dashed'
        ? `${borderSize} dashed ${theme.wrapper.border.color}`
        : theme.name === 'DARK' &&
          `${borderSize} solid ${theme.wrapper.border.color}`,
    ...style
  };

  return <Box sx={BoxStyle}>{children}</Box>;
};

export default AryWrapper;
